import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import newsData from '../news.json';

const News = () => {
  const { title, banners, news, footer } = newsData;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentBanner, setCurrentBanner] = useState(0);
  const itemsPerPage = 3;

  // 计算总页数
  const totalPages = Math.ceil(news.length / itemsPerPage);
  
  // 获取当前页的新闻
  const currentNews = news.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  // 生成页码数组
  const getPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  };

  // 自动轮播Banner - 4秒切换一次
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [banners.length]);

  return (
    <main className="pt-[60px] min-h-screen bg-white">
      {/* Banner Section */}
      <Link to={`/news/${banners[currentBanner].id}`} className="block relative h-[400px] md:h-[500px] bg-[#1a5681] flex items-center hover:bg-[#164a6d] transition-colors duration-300">
        <div className="container mx-auto px-6">
          <div className="flex items-center gap-3 mb-3">
            <span className="bg-white text-[#1a5681] text-xs font-bold px-3 py-1 rounded">
              {banners[currentBanner].tag}
            </span>
            <span className="text-white/80 text-sm">{banners[currentBanner].date}</span>
          </div>
          <h2 className="text-xl md:text-3xl font-bold text-white mb-2 max-w-3xl">{banners[currentBanner].title.en}</h2>
          <p className="text-white/90 text-sm md:text-base max-w-2xl">{banners[currentBanner].title.zh}</p>
        </div>
      </Link>

      {/* Header Section */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-6">
          <p className="text-[#1a5681] text-xs font-bold tracking-[0.2em] mb-2">{title.en}</p>
          <h1 className="text-3xl font-bold text-gray-900">{title.zh}</h1>
        </div>
      </section>

      {/* News List */}
      <section className="pb-12">
        <div className="container mx-auto px-6">
          <div className="space-y-6">
            {currentNews.map((item) => (
              <Link
                to={`/news/${item.id}`}
                key={item.id}
                className="block border-b border-gray-100 pb-6 last:border-0 group transition-all duration-300 hover:shadow-md p-4 rounded-lg hover:-translate-y-1"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="text-[#1a5681] text-xs font-bold tracking-wider">{item.category}</span>
                  <span className="text-gray-400 text-sm">{item.date}</span>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 group-hover:text-[#1a5681] transition-colors duration-300">{item.title.en}</h3>
                <p className="text-gray-600 text-sm mb-3">{item.title.zh}</p>
                <p className="text-gray-500 text-sm leading-relaxed">{item.summary.en}</p>
                <p className="text-gray-400 text-xs mt-2 leading-relaxed">{item.summary.zh}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Pagination */}
      <section className="pb-16">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-center gap-2">
            <button 
              onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
              disabled={currentPage === 1}
              className="w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-600 disabled:opacity-30 transition-colors"
            >
              <span className="material-symbols-outlined">chevron_left</span>
            </button>
            
            {getPageNumbers().map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`w-10 h-10 flex items-center justify-center text-sm font-medium rounded transition-colors ${
                  currentPage === page 
                    ? 'bg-[#1a5681] text-white' 
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                {page}
              </button>
            ))}
            
            <button 
              onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
              disabled={currentPage === totalPages}
              className="w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-600 disabled:opacity-30 transition-colors"
            >
              <span className="material-symbols-outlined">chevron_right</span>
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-50 py-8 border-t border-gray-200">
        <div className="container mx-auto px-6">
          <div className="flex flex-col items-center justify-center gap-4">
            <p className="text-gray-400 text-xs text-center">{footer.copyright}</p>
            <p className="text-gray-400 text-xs text-center">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="hover:underline">
                {footer.beian}
              </a>
            </p>
          </div>
        </div>
      </footer>
    </main>
  );
};

export default News;
